import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { CostFileTemplate } from 'shared/types/roi-hub/fileIngestion.types';

interface PatchPayload {
  id: string;
  body: Partial<CostFileTemplate>;
}

export const PatchCostFileTemplateAction = new ReduxAsyncAction<
  'ROI_COST_FILE_TEMPLATE_SETUP',
  PatchPayload,
  CostFileTemplate
>('ROI_COST_FILE_TEMPLATE_SETUP');

PatchCostFileTemplateAction.registerRequest(async (payload) => {
  try {
    const { id, body } = payload;
    const { data } = await dash_api.patch<CostFileTemplate>(`/v1/roi/cost-file-templates/${id}`, body);
    NotificationActions.showNotification('Patch complete ', 'success');

    return data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred when setting up cost file template', 'error');
    throw error;
  }
});

export const PATCH_COST_FILE_TEMPLATE_ACTION = PatchCostFileTemplateAction.actionNamespaceConstants;

export const patchCostFileTemplate = PatchCostFileTemplateAction.request;

export type PatchCostFileTemplateResponseAction = Action<typeof PATCH_COST_FILE_TEMPLATE_ACTION.response> & {
  data: CostFileTemplate;
};
